export default function Image(props) {
  const { tag, loading, src, alt, onClick, onError, style, className } = props;

  const Tag = tag || "article";

  return (
    <Tag
      style={style}
      className={`${className ? className : "frame"} element _image`}
      onClick={onClick ? onClick : undefined}
    >
      <img
        loading={loading === "eager" ? "eager" : "lazy"}
        src={src}
        alt={alt}
        onError={onError}
      />
    </Tag>
  );
}
